<script>
import { mapActions, mapGetters, mapState } from "vuex";

import professionalMixin from "@/mixins/accountable/professionalMixin";

import Loader from "@/components/_base/Loader";
import Star from "@/components/_base/Star";

export default {
  mixins: [professionalMixin],

  components: {
    Loader,
    Star
  },

  methods: {
    ...mapActions("orderScheduler", [
      "unsetScheduleConfirmation",
      "setScheduleConfirmation",
      "unsetProfessional"
    ]),

    totalOrders() {
      return this.$options.filters.orderCount(this.professional);
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "professional",
      "canShowProfessionalSchedule"
    ]),

    ...mapState("orderScheduler", [
      "scheduleConfirmed",
      "scheduleEventsPreloader",
      "orderOfferEnable"
    ])
  }
};
</script>

<template>
  <div class="professional-content">
    <span class="header">Profissional Selecionado(a)</span>

    <div class="professional-info">
      <div class="left" :class="{ 'left-fullwidth': !scheduleConfirmed }">
        <img class="profile-picture" :src="professional | profilePicture" />

        <div class="infos">
          <div class="name">
            <span>{{ professional | shorterFullName }}</span>

            <div class="rating">
              <Star />

              <span class="rating-number">
                {{ professional | rating }} <span class="feedback-count" v-if="professional.total_feedbacks_count > 3">({{ professional | feedbacks }})</span>
              </span>
            </div>
          </div>

          <div class="orders-count">
            {{ totalOrders() > 0 ? `${totalOrders()} limpezas  realizadas` : 'Novo(a) profissional' }}
          </div>
        </div>
      </div>

      <div
        v-if="scheduleConfirmed && !orderOfferEnable"
        class="right"
        @click="unsetScheduleConfirmation"
      >
        <img class="calendar" src="/static/calendar-edit-outlined.svg" />

        <span>agenda</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.professional-content {
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header {
  margin-bottom: 8px;
  font-size: 13px;
  color: #888;
  font-weight: 300;
}

.professional-info {
  width: 100%;
  display: flex;
  align-items: center;
}

.left {
  width: 80%;
  display: flex;
  align-items: center;
}

.left-fullwidth {
  width: 100%;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.infos {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.name {
  display: flex;
  color: #424242;
  font-size: 15px;
  font-weight: 400;
}

.rating {
  display: flex;
}

.rating > .rating-number {
  font-weight: 300;
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  border-left: solid 1px #ddd;
}

.orders-count {
  font-size: 13px;
}

.orders-count > span {
  font-weight: 400;
  color: #603285;
}

.right {
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: solid 1px #e2e2e2;
  cursor: pointer;
}

.right > img {
  width: 24px;
  height: 24px;
  margin-left: 4px;
}

.right > span {
  font-size: 12px;
  margin-top: 4px;
}

.feedback-count {
  margin-left: 4px;
}

@media (max-width: 375px) {
  .name {
    flex-direction: column;
    max-width: 90%;
  }

  .name > span,
  .orders-count {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 90%;
  }

  .name > .rating {
    margin-left: 0;
  }

  .right {
    padding-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Professional/Index.vue